export const schema = [
  {
    id: "/Page/Element/Type/Paragraph",
    type: "object",
    properties: {
      // The Quill delta, as the JSON string Quill itself round-trips. Not an
      // object: `getContents()` returns a Delta instance and the archived
      // project stored `JSON.stringify` of it, so every paragraph written by
      // gen-2 is a string — and datorm would have to be taught the shape of an
      // ops array to hold anything else.
      //
      // `{"ops":[]}` rather than "" is the empty document Quill's own
      // `setContents` accepts. An element added and never typed into still
      // parses.
      content: {
        label: "Content",
        type: "string",
        widget: "paragraph",
        default: `{"ops":[]}`,
      },
    },
    required: [],
  },
];
